// ranking-reveal 纯 SVG 渲染。复用 tick.rankingReveal 推导揭晓状态。
import type { SceneData } from '../../api/types'
import type { RankingData } from './types'
import { rankingReveal } from './tick'
import { COLORS, FONT_SANS, FONT_MONO, esc } from '../../export/svgRender'

export function render(data: SceneData, time: number): string {
  const d = data as unknown as RankingData
  const sorted = [...(d.items || [])].sort((a, b) => a.rank - b.rank)
  const { revealState, revealIdx } = rankingReveal(data, time)
  if (sorted.length === 0) return ''

  const idle = revealState === 'idle' || revealIdx >= sorted.length
  const top = sorted[0]
  const item = idle ? top : sorted[revealIdx]
  if (!item) return ''
  const bgItem = idle ? top : item
  const cx = 540

  const grad = `<defs><linearGradient id="rkg" x1="0" y1="1920" x2="430" y2="0" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="${bgItem.color}33"/><stop offset="1" stop-color="${COLORS.bg}" stop-opacity="0"/></linearGradient></defs>
  <rect x="0" y="0" width="1080" height="1920" fill="url(#rkg)"/>`

  if (idle) {
    return `${grad}
  <text x="${cx}" y="760" font-size="320" font-weight="800" fill="${top.color}" text-anchor="middle" dominant-baseline="middle" letter-spacing="-20" font-family="${FONT_SANS}">#${esc(top.rank)}</text>
  <text x="${cx}" y="1080" font-size="96" font-weight="700" fill="${COLORS.w}" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_SANS}">${esc(top.name)}</text>
  <text x="${cx}" y="1200" font-size="46" font-weight="400" fill="${COLORS.t2}" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_SANS}">${esc(top.desc)}</text>
  <text x="${cx}" y="1320" font-size="34" font-weight="500" fill="${COLORS.pHover}" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_SANS}">#${esc(d.title)}</text>`
  }

  return `${grad}
  <text x="${cx}" y="560" font-size="44" font-weight="600" fill="${COLORS.t3}" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_MONO}">${esc(sorted.length - revealIdx)}</text>
  <text x="${cx}" y="820" font-size="320" font-weight="800" fill="${item.color}" text-anchor="middle" dominant-baseline="middle" letter-spacing="-20" font-family="${FONT_SANS}">#${esc(item.rank)}</text>
  <text x="${cx}" y="1110" font-size="96" font-weight="700" fill="${COLORS.w}" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_SANS}">${esc(item.name)}</text>
  <text x="${cx}" y="1230" font-size="46" font-weight="400" fill="${COLORS.t2}" text-anchor="middle" dominant-baseline="middle" font-family="${FONT_SANS}">${esc(item.desc)}</text>`
}
